// extracted by mini-css-extract-plugin
export default {"aboutme":"AboutMe_aboutme__kjjDa","header":"AboutMe_header__J+xo+","learning":"AboutMe_learning__cD5sI","text":"AboutMe_text__nwC7K"};